<template>
  <div>


    <div role="dialog" class="offcanvas offcanvas-bottom" style="min-height:30vh ;" tabindex="-1" ref="offcanvasEl" :id="$props.idColumns" aria-labelledby="offcanvasTopLabel">
      <div class="offcanvas-header mb-0">
        <h5 id="offcanvasTopLabel">Seleção de Colunas do Grid</h5>
      
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
          ref="closeFilter"></button>

      </div>
      <div class="offcanvas-body ">
        <div class="row">

            <hr>
            <div class="d-flex justify-content-start">
              <template v-for="key in  Object.keys(grouped)" :key="key">
                <div class="pe-4 me-2 me-2" :class="{ 'border-end border-end-3': Object.keys(grouped).length > 1 }">
                  <label class="mb-2" v-if="Object.keys(grouped).length > 1">{{ key=='undefined'?"Principal": key }}</label>
                  <div class="form-check" v-for="column in  grouped[key]" :key="column.datafield">
                    <input type="checkbox" class="form-check-input" :checked="!column.hidden" :id="column.datafield"
                      @click="column.hidden = (column.hidden ? false : true); onClickCheckBox();">
                    <label class="form-check-label" :for="column.datafield">{{ column.text
                      }}</label>
                  </div>
                </div>
              </template>
            </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script lang="ts">
import { DataSource } from "@/datasources/consulte-grid";
import { GridActionTypes } from "@/store/grid/action-types";
import { focaveisDentro } from "@/uteis/dialogo-acessivel";
import { defineComponent } from "vue";
import { mapActions } from "vuex";
export default defineComponent({
  name: "ConsulteGridRowSelection",

  async mounted() {
    // Ao ABRIR o painel, leva o foco para o primeiro campo útil (ver focarPrimeiroCampo).
    // Mesma correção do ConsulteGridFilters: sem isto, abrir a seleção de colunas pelo teclado
    // deixava o foco fora do painel (ou no "X"), e o Tab seguinte "andava" pelo grid atrás do
    // offcanvas. Registrado ANTES do await: se o GET_GRID demorar ou lançar, o listener já existe.
    (this.$refs.offcanvasEl as HTMLElement | undefined)?.addEventListener(
      "shown.bs.offcanvas",
      this.focarPrimeiroCampo,
    );

    let gridState = await this[GridActionTypes.GET_GRID](this.$route.name);
    if (gridState && gridState.filters) {
      // this.dataSource!.filters = gridState.filters as FiltrosModel[];
      // this.dataSource!.filters.forEach(x => {
      //   x.filters.forEach(y => {
      //     this.filterAux[x.field] = y.value;
      //   })

      // })

    }

  },

  beforeUnmount() {
    (this.$refs.offcanvasEl as HTMLElement | undefined)?.removeEventListener(
      "shown.bs.offcanvas",
      this.focarPrimeiroCampo,
    );
  },

  data() {

    return {
      filterAux: {} as any,
      filtersData: {} as any,
      loading: true
    };
  },
  computed: {
    visibleColumns() {
      return this.columns?.filter(x => !x.hidden);
    },
    grouped() {
      return this.groupBy(this.columns!, "columngroup");
    }

  },
  methods: {
    ...mapActions([GridActionTypes.SET_FILTER, GridActionTypes.CLEAR_FILTERS, GridActionTypes.GET_GRID]),
    /*
     * Foco inicial do painel de seleção de colunas, no `shown.bs.offcanvas`. Leva o foco para o
     * primeiro controle útil (pulando o `.btn-close`), como o `abrirDialogo` faz nos modais e o
     * ConsulteGridFilters faz no painel de filtros.
     *
     * O FocusTrap do Bootstrap TRAVA o foco no contêiner do offcanvas por ~100ms após o `shown`
     * (autofocus): nesse intervalo `campo.focus()` é INERTE. Por isso reinsistimos a cada 50ms até
     * o foco assentar num controle do painel, ou desistimos após ~1s (aí fica no contêiner, que é
     * um `role="dialog"` rotulado — degradação aceitável). Enquanto a trava está ativa o focus() é
     * no-op, então NÃO pisca.
     *
     * A GUARDA `painel.contains(ativo)` garante que, se o foco JÁ está num controle do painel —
     * porque assentou OU porque o usuário clicou/tabulou num campo antes de a trava soltar — a
     * gente PARA e não rouba o foco de quem já entrou.
     */
    focarPrimeiroCampo() {
      const painel = this.$refs.offcanvasEl as HTMLElement | undefined;
      if (!painel) return;
      let tentativas = 0;
      const tentar = () => {
        const ativo = document.activeElement;
        if (ativo && ativo !== painel && painel.contains(ativo)) return;
        const uteis = focaveisDentro(painel);
        const primeiro = uteis.find((el) => !el.classList.contains("btn-close")) ?? uteis[0];
        if (!primeiro) return;
        primeiro.focus();
        tentativas += 1;
        if (tentativas < 20) window.setTimeout(tentar, 50);
      };
      tentar();
    },
    toJson(data: any) {
      return JSON.stringify(data);
    },
    onClickCheckBox() {
      this.$emit("update:columns", this.columns);
      console.log(this.columns)
    },
    groupBy(array: Array<any>, key: string) {
      return array.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    }

  },
  props: {
    columns: {
      type: Object as () => Array<any>
    },

    dataSource: {
      type: Object as () => DataSource<any>
    },
    idColumns: {
      type: String,
      required: true
    }
  },
});
</script>
<style lang="scss"></style>@/datasources/consulte-grid